import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import './App.scss';
//import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import store from './stores/store';

ReactDOM.render(<Provider store={store}><App/></Provider>, document.querySelector('#root'));

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
